/* @flow */
import * as React from 'react';
import classnames from 'classnames';

export type LabelType = {
  invalid?: boolean,
  required?: boolean,
  disabled?: boolean,
  hidden?: boolean,
  tag?: string,
  children?: React.Node,
};

const Label = ({
  required,
  invalid,
  disabled,
  hidden,
  tag = 'label',
  children,
  ...rest
}: LabelType) => {
  const labelClasses = classnames({
    label: true,
    'form-group__label': true,
    'label--invalid': invalid && invalid.toString(),
    'label--disabled': disabled && disabled.toString(),
    'u-hidden-visually': hidden,
  });
  const HtmlTag = tag;
  return (
    <HtmlTag
      {...rest}
      className={labelClasses}
      disabled={disabled ? 'disabled' : false}
      invalid={invalid ? 'invalid' : null}
      hidden={hidden}
    >
      {children}
      {required && (
        <abbr className="label__required" title="Pflichtfeld">
          *
        </abbr>
      )}
    </HtmlTag>
  );
};

export default Label;
